var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelinessBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 104,
    viewBox: "0 0 96 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1767_5180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7967 7.6762C46.6316 6.6364 48.8778 6.6364 50.7128 7.6762L80.0074 24.2763C81.8874 25.3416 83.0493 27.3355 83.0493 29.4964V62.5036C83.0493 64.6645 81.8874 66.6584 80.0074 67.7238L50.7128 84.3238C48.8778 85.3636 46.6316 85.3636 44.7967 84.3238L15.5021 67.7237C13.622 66.6584 12.4601 64.6645 12.4601 62.5036V29.4964C12.4601 27.3355 13.622 25.3416 15.5021 24.2762L44.7967 7.6762Z",
    fill: "url(#paint0_linear_1767_5180)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1767_5180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.898 52.3176C66.5913 52.011 66.1755 51.8388 65.7419 51.8388C65.3083 51.8388 64.8924 52.011 64.5858 52.3176L55.3844 61.5206L50.9889 57.1824C50.6853 56.8712 50.2706 56.6934 49.8359 56.688C49.4012 56.6826 48.9822 56.8502 48.671 57.1537C48.3598 57.4573 48.182 57.8721 48.1766 58.3068C48.1713 58.7415 48.3388 59.1605 48.6424 59.4717L53.1294 63.8868C53.4109 64.1902 53.7508 64.4336 54.1288 64.6022C54.5068 64.7708 54.915 64.8612 55.3288 64.8679H55.3828C55.7884 64.8692 56.1902 64.79 56.565 64.6348C56.9397 64.4795 57.2799 64.2514 57.5658 63.9636L66.898 54.6298C67.2045 54.3231 67.3768 53.9073 67.3768 53.4737C67.3768 53.0401 67.2045 52.6242 66.898 52.3176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2664 61.5306C43.1089 61.2421 40.1033 60.0418 37.6157 58.0759C35.128 56.1099 33.2655 53.4632 32.255 50.4578C31.2445 47.4525 31.1295 44.2182 31.924 41.1486C32.7185 38.0791 34.3883 35.3067 36.7301 33.1691C39.0718 31.0315 41.9846 29.6208 45.1136 29.1087C48.2427 28.5966 51.4532 29.0053 54.3542 30.285C57.2551 31.5647 59.7215 33.6602 61.4531 36.3163C63.1846 38.9725 64.1065 42.0747 64.1067 45.2454C64.1067 45.7475 64.0821 46.2446 64.0396 46.7351C64.0196 46.9495 64.0422 47.1658 64.1059 47.3714C64.1697 47.5771 64.2735 47.7681 64.4113 47.9336C64.5491 48.0991 64.7182 48.2357 64.909 48.3356C65.0997 48.4355 65.3083 48.4968 65.5228 48.5159C65.7371 48.5374 65.9536 48.516 66.1595 48.4527C66.3654 48.3895 66.5566 48.2857 66.7219 48.1476C66.8872 48.0094 67.0232 47.8396 67.1219 47.6482C67.2207 47.4567 67.2802 47.2475 67.297 47.0327C67.3493 46.4392 67.3771 45.8456 67.3771 45.2454C67.3769 41.4405 66.2705 37.7176 64.1925 34.5302C62.1146 31.3427 59.1547 28.8281 55.6733 27.2926C52.1919 25.7571 48.3392 25.2668 44.5842 25.8816C40.8292 26.4963 37.334 28.1895 34.524 30.755C31.714 33.3205 29.7105 36.6476 28.7574 40.3313C27.8043 44.015 27.9428 47.8963 29.1559 51.5027C30.369 55.1091 32.6045 58.285 35.5902 60.6438C38.5758 63.0025 42.1828 64.4423 45.9721 64.788H46.1209C46.5546 64.8073 46.9782 64.6535 47.2985 64.3605C47.6188 64.0675 47.8096 63.6592 47.8289 63.2255C47.8482 62.7918 47.6944 62.3682 47.4014 62.0479C47.1084 61.7276 46.7001 61.5368 46.2664 61.5175V61.5306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3287 36.3763V45.697L41.8336 51.1989C41.6397 51.3863 41.4851 51.6106 41.3787 51.8586C41.2723 52.1066 41.2163 52.3732 41.2139 52.6431C41.2116 52.913 41.263 53.1806 41.365 53.4304C41.4671 53.6802 41.6178 53.9071 41.8084 54.0979C41.999 54.2888 42.2257 54.4397 42.4751 54.5419C42.7246 54.6441 42.9919 54.6955 43.2615 54.6931C43.531 54.6908 43.7974 54.6347 44.045 54.5282C44.2927 54.4217 44.5167 54.2669 44.7039 54.0727L50.7938 47.9754C51.1745 47.5943 51.3885 47.0775 51.3886 46.5385V36.3763C51.3886 35.8372 51.1747 35.3203 50.794 34.9391C50.4133 34.5579 49.897 34.3438 49.3586 34.3438C48.8202 34.3438 48.3039 34.5579 47.9232 34.9391C47.5425 35.3203 47.3287 35.8372 47.3287 36.3763Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1767_5180",
    x: 0.460205,
    y: 0.896362,
    width: 94.5891,
    height: 102.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1767_5180"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1767_5180"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1767_5180",
    result: "effect2_dropShadow_1767_5180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1767_5180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1767_5180",
    x1: 27.7932,
    y1: 18.5,
    x2: 67.819,
    y2: 75.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C4D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1767_5180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.2453,
    height: 39.2453,
    fill: "white",
    transform: "translate(28.1318 25.6226)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelinessBadgeIcon);
export default __webpack_public_path__ + "static/media/timeliness-badge-icon.82a2aba4a4a611bdfa43eeed4d694deb.svg";
export { ForwardRef as ReactComponent };